export * from './tab2.component'